<template>
  <div>
    <div class="nav-vertical nav-vertical--nested" style="display: block">
      <div
        v-for="option in options"
        :key="option.id"
        class="nav-vertical__item flex-wrap cursor-pointer filterOptionListItem py-1"
      >
        <c-new-filter-item-checkbox-option
          v-bind="option"
          @input="onInput"
          :radio="radio"
        ></c-new-filter-item-checkbox-option>
      </div>
    </div>
  </div>
  
</template>

<script>
import NewFilterItemCheckboxOption from '@/components/pages/filter/checkbox/NewFilterItemCheckboxOption.vue'

export default {
  components: { 'c-new-filter-item-checkbox-option': NewFilterItemCheckboxOption },
  props: { options: { required: true, type: Array }, radio: Boolean },
  methods: {
    onInput(e) {
      this.$emit('filter-selected', e)
    },
    onOptions(){

    }
  },
}
</script>
